<template>
  <div class="shop-block goods">
    <preloader :visible="preloader" />
    <v-server-table id="goods-table" ref="goods-table" :url="route" :columns="columns" :options="options"
                    @loading="onLoading" @loaded="onLoaded" >

      <template v-slot:name="ctx"><div class="text--primary body-1">{{ getItemName(ctx.row) }}</div></template>
      <template v-slot:price="ctx">{{ ctx.row.price }}</template>
      <template v-slot:qty="ctx">
        <v-text-field class="numeric" hide-details dense single-line
                      :value="getItemQty(ctx.row)" v-on:input="setItemQty(ctx.row, $event)" />
      </template>
      <template v-slot:total="ctx"><div :id="`item-${ctx.row.id}-total`">0.00</div></template>
      <template v-slot:actions="ctx"><div class="actions-bts nobr">
        <a :class="'mr-2 mb-2 btn btn-sm ' + (ctx.row.enabled ? 'btn-success' : 'btn-disabled')" v-on:click="toggleEnabled(ctx.row)" v-if="canEdit">
          <i :class="(ctx.row.enabled ? 'icmn-checkbox-checked2' : 'icmn-checkbox-unchecked2')" />
        </a>
        <a class="mr-2 mb-2 btn btn-sm btn-primary" v-on:click="editItem(ctx.row)" v-if="canEdit"><i class="icmn-pencil3" /></a>
        <a class="mr-2 mb-2 btn btn-sm btn-danger" v-on:click="tryDeleteItem(ctx.row.id)" v-if="canDelete"><i class="icmn-bin" /></a>
      </div></template>

      <template v-slot:appendBody>
        <tr>
          <td id="items-selected">{{ orderItems.length }} item(s) selected.</td>
          <td colspan="2">&nbsp;</td>
          <td id="items-total-price">{{ totalPrice }}</td>
          <td><div class="actions-bts">
            <a v-if="totalPrice > 0.0" class="mr-2 mb-2 btn btn-sm btn-success" v-on:click="submitOrder">Submit</a>
            <div v-else class="mr-2 mb-2 btn v-btn--disabled btn-sm">Submit</div>
          </div></td>
        </tr>
        <tr v-if="canAdd">
          <td><v-text-field dense single-line v-model="newItem.name" :rules="[rules.hasName]"/></td>
          <td><v-text-field class="numeric" dense single-line v-model="newItem.price" :rules="[rules.hasPrice]" /></td>
          <td colspan="2">&nbsp;</td>
          <td><div class="actions-bts">
            <a v-if="addAllowed" class="mr-2 mb-2 btn btn-sm btn-danger" v-on:click="tryAddItem"><i class="icmn-plus2" /></a>
            <div class="mr-2 mb-2 btn v-btn--disabled btn-sm" v-else><i class="icmn-plus2" /></div>
          </div></td>
        </tr>
      </template>
    </v-server-table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";

export default {
  components: { Preloader },
  props: {
    route: {
      type: String
    },
    canAdd: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      preloader: false,
      rules: {
        hasName: v => v.trim().length > 0 || 'Must be non-empty!',
        hasPrice: v => v > 0.0 || 'Incorrect value!'
      },
      message: '',
      basket: [],
      basketUpdate: false,
      newItem: {
        id: null,
        name: '',
        price: 0.0
      },
      columns: [ 'name', 'price', 'qty', 'total' ]
          .concat(this.canEdit || this.canDelete ? [ 'actions' ] : []),
      options: {
        columnsClasses: {
          name: 'text-left',
          price: 'width-100',
          qty: 'width-100',
          total: 'width-100',
          actions: 'min-width'
        },
        filterByColumn: true,
        debounce: 1000,
        sortable: [ 'name' ],
        filterable: [ 'name' ],
        perPage: 30,
        pagination: {
          chunk: 30,
          dropdown: false
        },
        headings: {
          name: 'Name',
          price: 'Price',
          qty: 'Qty',
          total: 'Total',
          actions: 'Actions',
        },
      }
    }
  },
  computed: {
    addAllowed: function() {
      return true === this.rules.hasName(this.newItem.name) && true === this.rules.hasPrice(this.newItem.price);
    },
    orderItems: function() {
      this.basketUpdate;
      return this.basket.filter(v => v.qty > 0);
    },
    totalPrice: function() {
      this.basketUpdate;
      return this.orderItems.reduce((a, v) => (a + v.qty * v.price), 0).toFixed(2);
    }
  },
  methods: {
    getItemName(item) {
      return item.name;
    },
    getItemQty(item) {
      return (this.basket[item.id] ? this.basket[item.id].qty : 0) || 0;
    },
    setItemQty(item, qty) {
      if (!this.basket[item.id]) this.basket[item.id] = item;
      this.basket[item.id].qty = parseInt(qty);
      this.updateItemTotal(item);
    },
    resetBasket() {
      this.orderItems.forEach(v => $(`#item-${v.id}-total`).text((0).toFixed(2)));
      this.basket = [];
      this.basketUpdate = !this.basketUpdate;
    },
    updateItemTotal(item) {
      $(`#item-${item.id}-total`).text((this.getItemQty(item) * parseFloat(item.price)).toFixed(2));
      this.basketUpdate = !this.basketUpdate;
    },

    onLoading() {
      this.preloader = true;
    },
    onLoaded() {
      this.preloader = false;
    },


    toggleEnabled(item) {
      const self = this;
      return axios.post(`/api/shop/${item.id}/enable?v=` + (item.enabled ? 0 : 1)).then(r => {
        if (r.data.error) {
          self.toast(r.data.error, 'error');
        } else {
          self.toast(r.data.success);
        }
      }).then(() => {
        this.$refs['goods-table'].getData();
      }).catch(e => {
        console.log(e);
        self.toast('Server error.', 'error');
      });
    },
    editItem(item) {
      this.newItem = { id:item.id, name:item.name, price:item.price };
    },
    tryAddItem() {
      if (!this.addAllowed) {
        return self.toast('Name and price must be valid to add new item.', 'error');
      }
      this.addItem(this.newItem).then(() => {
        this.newItem = { name: '', price: 0.0 };
        this.$refs['goods-table'].getData();
      });
    },
    addItem(item) {
      const self = this;
      return axios.post(`/api/shop/create`, { id: item.id, name: item.name, price: item.price }).then(r => {
        if (r.data.error) {
          self.toast(r.data.error, 'error');
        } else {
          self.toast(r.data.success);
        }
      }).catch(e => {
        console.log(e);
        self.toast('Item was not added because of server error.', 'error');
      });
    },
    tryDeleteItem(id) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: 'You would not be able to recover this item!',
        icon: 'warning',
        confirmButtonText: 'Delete',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteItem(id).then(() => {
            this.$refs['goods-table'].getData();
          });
        }
      });
    },
    deleteItem(id) {
      const self = this;
      return axios.delete(`/api/shop/${id}`).then(r => {
        if (r.data.error) {
          self.toast(r.data.error, 'error');
        } else {
          self.toast(r.data.success);
        }
      }).catch(e => {
        console.log(e);
        self.toast('Item was not deleted because of server error.', 'error');
      });
    },
    submitOrder() {
      const self = this;
      const order = this.orderItems.map(function (v) { return { id:v.id, qty:v.qty }; });
      console.debug('submitOrder', order);
      return axios.post('/api/shop/order', { order }).then(r => {
        if (r.data.error) {
          self.toast(r.data.error, 'error');
        } else {
          self.toast(r.data.success);
        }
      }).then(() => {
        self.resetBasket();
      }).catch(e => {
        console.log(e);
        self.toast('Server error.', 'error');
      });
    },

    toast(message, type) {
      const self = this.$swal;
      self.fire({
        text: message,
        icon: type || 'success',
        toast: true,
        showConfirmButton: false,
        position: 'top-end',
        timer: 1500,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', self.stopTimer)
          toast.addEventListener('mouseleave', self.resumeTimer)
        }
      });
    },
  }
}
</script>
